// Minimal helpers to allow unquoted values in JSON-like strings

// Quote bracketed placeholder tokens (e.g., [PLACEHOLDER_FOO]) when used as values
// Only match uppercase letters/digits/underscores to avoid matching real arrays like : [1, 2]
const quoteBracketValues = s => s.replace(/(:\s*)(\[[A-Z0-9_]+\])/g, (m, p1, token) => {
	const escaped = token.replace(/"/g, '\\"')
	return `${p1}"${escaped}"`
})

// Quote unquoted value tokens after a colon, capturing until the next delimiter (comma, closing brace/bracket, or newline)
// This ensures full URLs and similar tokens are quoted correctly
const quoteBarewordValues = s => s.replace(/(:\s*)([^,}\]\r\n]+)/g, (m, p1, rawVal) => {
	const value = (rawVal || '').trim()
	const lower = value.toLowerCase()
	// Keep booleans/null as-is
	if (lower === 'true' || lower === 'false' || lower === 'null') return m
	// Skip if already a string/object/array
	const first = value[0]
	if (first === '"' || first === '{' || first === '[') return m
	// Skip numbers (int/float/scientific)
	if (/^-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/.test(value)) return m
	// Otherwise, wrap the full token in quotes
	const escaped = value.replace(/"/g, '\\"')
	return `${p1}"${escaped}"`
})

export function relaxJsonString (input) {
	if (typeof input !== 'string') return input
	let out = input
	// Leave numbers, existing strings, objects, and arrays as-is; just quote obvious barewords
	out = quoteBracketValues(out)
	out = quoteBarewordValues(out)
	return out
}

export function parseLenientJson (input) {
	if (typeof input !== 'string') return input
	try {
		return JSON.parse(input)
	} catch (e) {
		const relaxed = relaxJsonString(input)
		return JSON.parse(relaxed)
	}
}

export function isLenientJsonValid (input) {
	if (input == null || (typeof input === 'string' && input.trim() === '')) return true
	try {
		parseLenientJson(input)
		return true
	} catch (e) {
		return false
	}
}
